<template>
  <div class="main-body">
    <div class="header">
      商家订单统计
    </div>
    <div class="out">
      <div class="search2">

        <div style="float: right">

          <el-date-picker style="margin-right: 10px;width:250px;" title="起止时间" size="mini"
                          v-model="startEndTime"
                          type="daterange"
                          value-format="yyyy-MM-dd"
                          format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始时间"
                          end-placeholder="结束时间">
          </el-date-picker>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" :data="tableData" v-loading="tableLoading" :height="th" border style="width: 100%;">
        <el-table-column prop="name" label="商家名称" ></el-table-column>

        <el-table-column prop="serveOrderSingleCount" label="单独服务订单数"  ></el-table-column>
        <el-table-column prop="serveOrderMulCount" label="合并服务订单数"  ></el-table-column>

        <el-table-column prop="serveOrderSinglePrice" label="单独服务订单金额" :formatter="formatPrice"></el-table-column>
        <el-table-column prop="serveOrderMulPrice" label="合并服务订单金额" :formatter="formatPrice"></el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Info ref="myInfo" v-show="showModalInfo"  v-bind:areaValue="areaValue"  v-on:closeInfo="closeInfo" v-on:getList="getList"></Info>

  </div>
</template>

<script>

import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import Info from "./Info";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "Role",
  data(){
    return{

      orderTypeList: [
        {
          value: -1, label: '全部订单'
        }, {
          value: 1, label: '普通商品订单'
        }, {
          value: 2, label: '社会化服务订单'
        },
      ],

      tableLoading:false,

      businessList:[],
      showModalAdd:false,
      showModalInfo:false,
      tableData:null,
      zoneValue:[],
      areaValue:[],
      datetimerangeValue:'',
      idNumber:'',
      phone:'',
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      th:0,
      name:'',
      zoneCode:'',
      zoneProps:{
        emitPath:false,
        value: 'zoneCode',
        // 显示的文字字段名
        label: 'name',
        // 子层级字段名
        children: 'listZoneDTO'
      },
      searchData:[],
      searchForm:{
        startTime:'',
        endTime:'',
      },


      startEndTime:[],

    }
  },
  components:{
    Info,
  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      console.log(val);
      this.th = val;
    },
  },
  methods:{
    init(){

      // this.searchData=[
      //   {span:24,name:'起止时间',width:495,value:'daterange',type:'slot'},
      // ]
      // this.searchForm.endTime = getMonthDay("e",0);
      // this.searchForm.startTime = getMonthDay("s",0);


      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
      this.startEndTime = [start, end];

      this.getList();

    },
    handleInfo(index, row) {
      this.$refs.myInfo.init(row,this.searchForm);
      this.showModalInfo = !this.showModalInfo;
    },
    toggleModalAdd:function(){
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    formatPrice(row, column, cellValue){
      return cellValue.toFixed(2);
    },
    getZoneValue(val){
      this.zoneCode=val
    },
    searchGetList(){
      this.getList();
    },

    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      var _this=this

      let data={
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
        staffCode: getStaffCode(),
        pageIndex:this.currentPage,
        pageSize:this.pageSize,
        startTime: timefilters(this.startEndTime[0]).substring(0,10),
        endTime: timefilters(this.startEndTime[1]).substring(0,10),
      }


      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/OrderBusinessTotal",
        data: data
      }).then( (response)=> {
        //console.log(response);
        _this.tableLoading=false

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
